import type SchedulingPolicy from 'owa-service/lib/contract/SchedulingPolicy';
import type { BookingSchedulingPolicy } from 'owa-graph-schema';
import mapBookingServiceWindows from './mapBookingServiceWindows';
import convertMinutesToIsoDuration from '../utils/convertMinutesToIsoDuration';
import convertDaysToIsoDuration from '../utils/convertDaysToIsoDuration';

const mapSchedulingPolicy = (
    schedulingPolicy: SchedulingPolicy | undefined
): BookingSchedulingPolicy | undefined => {
    if (!schedulingPolicy) {
        return;
    }

    const {
        LeadTimeInMinutes,
        EndOfBookingWindowInDays,
        TimeSlotIntervalInMinutes,
        SendConfirmationsToMailboxOwner,
        AllowStaffSelection,
        ServiceBookableWindows,
        SendMeetingInviteToCustomer,
    } = schedulingPolicy;

    const modifiedSchedulingPolicy: BookingSchedulingPolicy = {
        allowStaffSelection: AllowStaffSelection,
        maximumAdvance: convertDaysToIsoDuration(EndOfBookingWindowInDays),
        minimumLeadTime: convertMinutesToIsoDuration(LeadTimeInMinutes),
        sendConfirmationsToOwner: SendConfirmationsToMailboxOwner,
        timeSlotInterval: convertMinutesToIsoDuration(TimeSlotIntervalInMinutes),
        bookingServiceWindows: mapBookingServiceWindows(ServiceBookableWindows),
        sendMeetingInviteToCustomer: SendMeetingInviteToCustomer,
    };

    return modifiedSchedulingPolicy;
};

export default mapSchedulingPolicy;
